import { Paper, Stack, Typography } from "@mui/material"
import { LeadMeta } from "../table/leadTableTypes"
import { dashedToUnderscored, ExternalFilters, getStatusFilterValues } from "../leadTableQuery"
import StatusFilterButton from "./StatusFilterButton"
import colors from "lib/colors"


export const DISPLAYED_LEAD_STATUSES = [
  'new-lead',
  'applied',
  'enrolled',
  'started',
  'filtered',
  'returned',
  'rejected',
  'error',
]

type LeadCountRowProps = {
  leadMeta: LeadMeta | undefined
  externalFilters: ExternalFilters
  onToggleStatusFilter: (status: string) => void
  loading: boolean
}

export function LeadCountRow({
  leadMeta,
  externalFilters,
  onToggleStatusFilter,
  loading,
}: LeadCountRowProps) {
  const leadCount = leadMeta?.total ?? 0
  const leadStatusCounts = leadMeta?.['counts-by-status'] ?? {}
  const selectedStatuses = getStatusFilterValues(externalFilters)

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      gap={3}
      alignItems='stretch'
      sx={{ mb: 3, flexShrink: 0 }}
    >
      <Paper
        sx={{
          p: 2.5,
          display: 'flex',
          flexDirection: 'column',
          flex: {
            xs: '1 1 auto',
            md: '0 0 180px',
          },
        }}
      >
        <Typography variant='body2' sx={{ color: colors.slateGray }}>Total Leads</Typography>
        <Typography variant='h1' sx={{ fontWeight: 700, fontSize: 24 }}>
          {leadCount.toLocaleString()}
        </Typography>
      </Paper>

      <Paper
        sx={{
          p: 2.5,
          flex: '1 1 auto',
          minWidth: 0,
        }}
      >
        <Typography variant='body2' sx={{ color: colors.slateGray }}>Lead Statuses</Typography>

        <Stack
          direction='row'
          gap={1}
          alignItems='center'
          flexWrap='wrap'
          sx={{ mt: 1 }}
        >
          {DISPLAYED_LEAD_STATUSES.map((status) => {
            const filterStatus = dashedToUnderscored(status)
            const noStatusesSelected = selectedStatuses.length === 0
            const thisStatusSelected = selectedStatuses.includes(filterStatus)
            const statusCount = leadStatusCounts[status]

            const shouldRenderCount =
              typeof statusCount === 'number' &&
              (noStatusesSelected || thisStatusSelected) &&
              !(loading && noStatusesSelected)

            return (
              <StatusFilterButton
                key={status}
                status={status}
                count={statusCount ?? 0}
                showCount={shouldRenderCount}
                selected={thisStatusSelected}
                onClick={() => onToggleStatusFilter(status)}
              />
            )
          })}
        </Stack>
      </Paper>
    </Stack>
  )
}
